<!--
 * @Description: 子系统介绍 详情
 * @Author: PF
 * @Date: 2024-03-12 10:11:26.395
 * @LastEditors: PF
 * @LastEditTime: 2024-03-13 15:17:25
-->
<template>
  <div>
    <el-dialog class="wp70 hp90" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">系统介绍</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-card shadow="never" class="hp100">
        <template #header v-if="ruleForm.zxtmc">
          <div class="card-header">
            <h2>{{ruleForm.zxtmc}}</h2>
          </div>
        </template>
        <div class="nei-rong" v-if="ruleForm.zxtjs">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zxtjs"></p>
        </div>
        <el-empty class="hp100" v-else />
      </el-card>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/sys/zixitongjieshao/zixitong/' + props.row.xtid,
        ruleForm,
        loadSuccess: function (res) {
          ruleForm.value = res.data || {}
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.el-card__header) {
  text-align: center;
}
:deep(.el-card__body) {
  height: calc(100% - 70px);
    overflow: auto;
}
.fu-biao-ti {
  color: #73767a;
  margin-top: 10px;
  span {
    margin: 0 10px;
  }
}
.nei-rong {
  color: #73767a;
  line-height: 30px;
}
</style>
